/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import IssuesTable from '../../components/customTables/tasks/issuesTable';
import SearchHeader from '../../components/searchHeader';

/**
 * Style Imports
 */
import { TaskContainer } from './styles/PatientViews.styles';

interface IssuesPageProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const PatientIssues: FC<IssuesPageProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <TaskContainer id="patient-issues" data-testid="patient-issues">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <IssuesTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default PatientIssues;
